// Text Fit - Variable Width Font Fitting
// Fits .text-fit elements to their parent width using binary search on the wdth axis.

const WDTH_AXIS_MIN = 0;
const WDTH_AXIS_MAX = 23000;
const SEARCH_STEPS = 14;
const SIZE_SCALE_MIN = 0.01;
const SIZE_SCALE_MAX = 64;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function fitToWidth(container, text, targetWidth) {
  if (!container || !text || !Number.isFinite(targetWidth) || targetWidth <= 0) return null;

  let currentAxis = WDTH_AXIS_MIN;

  // 前回の値をリセットしてから計測する
  container.style.setProperty('--text-fit-size-scale', '1');

  const setWidthAxis = (value) => {
    currentAxis = clamp(value, WDTH_AXIS_MIN, WDTH_AXIS_MAX);
    container.style.setProperty('--text-fit-width-axis', currentAxis.toFixed(2));
  };

  const measureWidth = () => text.getBoundingClientRect().width;

  setWidthAxis(WDTH_AXIS_MIN);
  const widthAtMinAxis = measureWidth();
  setWidthAxis(WDTH_AXIS_MAX);
  const widthAtMaxAxis = measureWidth();

  if (
    !Number.isFinite(widthAtMinAxis) ||
    !Number.isFinite(widthAtMaxAxis) ||
    widthAtMinAxis <= 0 ||
    widthAtMaxAxis <= 0
  ) {
    return null;
  }

  const isAscending = widthAtMaxAxis >= widthAtMinAxis;
  const axisForNarrowest = isAscending ? WDTH_AXIS_MIN : WDTH_AXIS_MAX;
  const axisForWidest = isAscending ? WDTH_AXIS_MAX : WDTH_AXIS_MIN;
  const narrowestWidth = Math.min(widthAtMinAxis, widthAtMaxAxis);
  const widestWidth = Math.max(widthAtMinAxis, widthAtMaxAxis);

  if (targetWidth >= widestWidth) {
    setWidthAxis(axisForWidest);
    // wdth軸だけでは足りない場合、font-sizeをスケーリング
    const scale = targetWidth / widestWidth;
    container.style.setProperty('--text-fit-size-scale', clamp(scale, SIZE_SCALE_MIN, SIZE_SCALE_MAX).toFixed(4));
  } else if (targetWidth <= narrowestWidth) {
    setWidthAxis(axisForNarrowest);
    const scale = targetWidth / narrowestWidth;
    container.style.setProperty('--text-fit-size-scale', clamp(scale, SIZE_SCALE_MIN, SIZE_SCALE_MAX).toFixed(4));
  } else {
    let lowAxis = axisForNarrowest;
    let highAxis = axisForWidest;
    let bestAxis = lowAxis;

    for (let i = 0; i < SEARCH_STEPS; i++) {
      const midAxis = (lowAxis + highAxis) / 2;
      setWidthAxis(midAxis);
      const midWidth = measureWidth();
      if (!Number.isFinite(midWidth) || midWidth <= 0) break;

      if (midWidth <= targetWidth) {
        bestAxis = midAxis;
        lowAxis = midAxis;
      } else {
        highAxis = midAxis;
      }
    }

    setWidthAxis(bestAxis);
    container.style.setProperty('--text-fit-size-scale', '1');
  }

  // 最終幅がまだはみ出す場合の微調整
  const finalWidth = measureWidth();
  if (Number.isFinite(finalWidth) && finalWidth > targetWidth + 0.5) {
    const currentScale = parseFloat(container.style.getPropertyValue('--text-fit-size-scale')) || 1;
    container.style.setProperty('--text-fit-size-scale', (currentScale * targetWidth / finalWidth).toFixed(4));
  }

  return { targetAxis: currentAxis, targetWidth };
}

// Auto-initialize all .text-fit elements
function fitAll() {
  document.querySelectorAll('.text-fit').forEach((container) => {
    const text = container.querySelector('.text-fit-text');
    if (!text) return;
    const targetWidth = container.clientWidth;
    fitToWidth(container, text, targetWidth);
  });
}

function revealAll() {
  document.querySelectorAll('.text-fit').forEach((container) => {
    container.classList.add('is-placed');
  });
}

document.fonts.ready.then(() => {
  fitAll();
  revealAll();
});

window.addEventListener('resize', fitAll);
